(function () {
  "use strict";
  
  angular.module("app").directive("hueChartColorsUniqueWithLevelsAuto", [
    "common",
    "config",
    "chartsHelper",
    "reduceValue",
    function (common, config, chartsHelper, reduceValue) {
      function link(scope, element, attributes) {
        scope.$watch("data", (newValue, oldValue) => {
          if (newValue) {
            bindData();
          }
        });

        function bindData() {
          if (!scope.data) {
            return;
          }

          const containerUnique = element
            .find('[chart-type="unique"]')
            .html("");
          const containerLevels = element
            .find('[chart-type="levels"]')
            .html("");
          const containerGroups = element
            .find('[chart-type="groups"]')
            .html("");

          const options = {};
          options.layout = {
            sections: {
              horizontal: 7,
              vertical: 2,
            },
          };
          options.data = options.data || {};
          if (!scope.data.grouped) {
            options.layout = {
              sections: {
                horizontal: 1,
                vertical: 1,
              },
            };
          }
          scope.RBGData = scope.data.unique;
          scope.RBGData = _.sortBy(
            _.map(scope.RBGData, function (d) {
              d.__order = Math.random();
              return d;
            }),
            "__order"
          );

          const colors = _.map(scope.data.groups, function (d) {
            const value = Math.round(d.percentage);
            return {
              value: reduceValue.reduce(d.count),
              valueTitle: Math.round(value) + "%",
              value2: reduceValue.reduce(d.count),
              valueTitle2: Math.round(d.percentage * 100),
              title: d.family,
              color: d.hex,
            };
          });

          let ch = new chartDotsHorizontal({
            data: colors,
            container: containerGroups[0],
            options: {},
          });
        }
        const windowResizeHandler = _.debounce(bindData, 200);
        scope.$on("$destroy", function () {
          $(window).off("resize", windowResizeHandler);
        });
        $(window).resize(windowResizeHandler);
      }

      const directive = {
        link: link,
        restrict: "E",
        replace: true,
        scope: {
          data: "=",
          board: "=",
        },
        templateUrl:
          "app/directives/custom-infographics-directives/chart-colors-unique-with-levels-auto.html",
      };

      return directive;
    },
  ]);
})();
